import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    "MobileMenuContainer",
    "MobileMenuOverlay",
    "MobileOffCanvasMenu",
    "CloseButton",
    "HeadingAnchor"
  ]

  connect() {
    this.element[this.identifier] = this
  }

  onOpenMenu() {
    this.MobileMenuContainerTarget.classList.remove("hidden")
    this.MobileMenuOverlayTarget.classList.remove("opacity-0")
    this.MobileMenuOverlayTarget.classList.add("opacity-100")
    this.MobileOffCanvasMenuTarget.classList.remove("-translate-x-full")
    this.MobileOffCanvasMenuTarget.classList.add("translate-x-0")
    this.CloseButtonTarget.classList.remove("opacity-0")
    this.CloseButtonTarget.classList.add("opacity-100")
  }

  onCloseMenu() {
    this.MobileMenuContainerTarget.classList.add("hidden")
    this.MobileMenuOverlayTarget.classList.add("opacity-0")
    this.MobileMenuOverlayTarget.classList.remove("opacity-100")
    this.MobileOffCanvasMenuTarget.classList.add("-translate-x-full")
    this.MobileOffCanvasMenuTarget.classList.remove("translate-x-0")
    this.CloseButtonTarget.classList.add("opacity-0")
    this.CloseButtonTarget.classList.remove("opacity-100")
  }

  onSidebarLinkClick(e) {
    let id = e.target.dataset.id
    let anchor = this.HeadingAnchorTargets.find((target) => target.id == id)
    anchor.scrollIntoView()
    this.onCloseMenu()
  }
}